export default __webpack_public_path__ + "static/media/1.3fa838b6.png";